import { type InquiryStage } from "../../hooks/use-inquiries";
import { useMemo } from "react";
import { isInquiryTabActive } from "./inquiry-tab-active";

export const useInquiryTabActive = (searchParam: string, statuses: InquiryStage[]) => {
  const result = useMemo(() => isInquiryTabActive(searchParam, statuses), [searchParam, statuses]);

  return result;
};
